import { SellTreez } from '@/models/sellTreez'

import { BackendResourcesFormData, IndexFormData, IndexWithName } from '../data/types'
import { CreateIndexRequest } from '@/models/indices'

export const getPosEntityFromIndexName = (indexName?: string): string => {
  if (!indexName?.startsWith('product_')) return ''
  return indexName.slice('product_'.length)
}

const escapeCsvValue = (value: string | number | undefined | null): string => {
  const str = String(value ?? '')
  if (/[",\n\r]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`
  }
  return str
}

const downloadCsv = (filename: string, headers: string[], rows: (string | number | undefined | null)[][]) => {
  const csvContent = [headers, ...rows].map((row) => row.map(escapeCsvValue).join(',')).join('\n')
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

export const exportIndexesToCsv = (indexes: IndexWithName[], filename = 'indexes.csv') => {
  const headers = ['ID', 'Name', 'pos_entity', 'Entity Name', 'Store Size', 'Docs Count', 'Status', 'Health']
  const rows = indexes.map((index) => [
    index.uuid ?? index.posEntity ?? getPosEntityFromIndexName(index.index) ?? '',
    index.index ?? '',
    index.posEntity ?? getPosEntityFromIndexName(index.index) ?? '',
    index.entityName ?? '',
    index['store.size'] ?? '0',
    index['docs.count'] ?? '0',
    index.status ?? '',
    index.health ?? '',
  ])

  downloadCsv(filename, headers, rows)
}

export const sanitizeFormData = (data: BackendResourcesFormData): SellTreez => {
  return {
    ...data,
    events: {
      ...data.events,
      source: JSON.parse(data.events.source.trim()),
      detailType: JSON.parse(data.events.detailType.trim()),
      externalAccountId: JSON.parse(data.events.externalAccountId.trim()),
    },
  }
}

export const sanitizeIndexFormData = (data: IndexFormData): CreateIndexRequest => {
  return {
    index: data.index,
    body: {
      properties: JSON.parse(data.body.properties.trim()),
    },
  }
}
